import MultiTenancyAdapter from './multi-tenancy';

export default class TenantAdapter extends MultiTenancyAdapter {
  urlForCreateRecord(modelName, snapshot) {
    let url = this.buildURL(modelName, null, snapshot, 'v3');
    url += '?include=tenant-connection-request';
    return url;
  }
}
